// Mock data for local development — realistic KaiAndCo deployments

import type { OverviewResponse, TeamDetailResponse, PlatformHealthResponse } from './types';

export const mockOverview: OverviewResponse = {
  teams: [
    {
      team_id: 'lumiden',
      domain: 'lumiden.kaiandco.ai',
      status: 'active',
      created_at: '2025-01-15T10:00:00Z',
      agent_count: 5,
      member_count: 3,
      services: {
        total: 7,
        healthy: 6,
        unhealthy: 1,
        list: [
          { name: 'synapse', full_name: 'lumiden-synapse', status: 'ACTIVE', running: 0, desired: 1, pending: 0, healthy: false },
          { name: 'kai', full_name: 'lumiden-kai', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'mia', full_name: 'lumiden-mia', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'finn', full_name: 'lumiden-finn', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'sam', full_name: 'lumiden-sam', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'luna', full_name: 'lumiden-luna', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'webapp', full_name: 'lumiden-webapp', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
        ],
      },
    },
    {
      team_id: 'acme-corp',
      domain: 'acme-corp.kaiandco.ai',
      status: 'active',
      created_at: '2025-02-20T14:30:00Z',
      agent_count: 3,
      member_count: 8,
      services: {
        total: 5,
        healthy: 5,
        unhealthy: 0,
        list: [
          { name: 'synapse', full_name: 'acme-corp-synapse', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'kai', full_name: 'acme-corp-kai', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'finn', full_name: 'acme-corp-finn', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'sam', full_name: 'acme-corp-sam', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'webapp', full_name: 'acme-corp-webapp', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
        ],
      },
    },
    {
      team_id: 'beta-test',
      domain: 'beta-test.kaiandco.ai',
      status: 'active',
      created_at: '2025-03-01T09:00:00Z',
      agent_count: 2,
      member_count: 1,
      services: {
        total: 4,
        healthy: 4,
        unhealthy: 0,
        list: [
          { name: 'synapse', full_name: 'beta-test-synapse', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'kai', full_name: 'beta-test-kai', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'mia', full_name: 'beta-test-mia', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
          { name: 'webapp', full_name: 'beta-test-webapp', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true },
        ],
      },
    },
    {
      team_id: 'staging',
      domain: 'staging.kaiandco.ai',
      status: 'hibernated',
      created_at: '2024-12-01T12:00:00Z',
      agent_count: 5,
      member_count: 2,
      services: {
        total: 7,
        healthy: 0,
        unhealthy: 0,
        list: [],
      },
    },
  ],
  summary: {
    team_count: 4,
    total_services: 23,
    healthy_services: 15,
    unhealthy_services: 1,
  },
  is_platform_admin: true,
};

export const mockTeamDetail: Record<string, TeamDetailResponse> = {
  lumiden: {
    team: {
      team_id: 'lumiden',
      domain: 'lumiden.kaiandco.ai',
      status: 'active',
      created_at: '2025-01-15T10:00:00Z',
    },
    agents: [
      { agent_id: 'kai', status: 'running', installed_at: '2025-01-15T10:05:00Z' },
      { agent_id: 'mia', status: 'running', installed_at: '2025-01-15T10:05:00Z' },
      { agent_id: 'finn', status: 'running', installed_at: '2025-01-20T14:00:00Z' },
      { agent_id: 'sam', status: 'running', installed_at: '2025-01-20T14:00:00Z' },
      { agent_id: 'luna', status: 'running', installed_at: '2025-02-01T09:00:00Z' },
    ],
    members: [
      { user_id: '@sean:lumiden.kaiandco.ai', display_name: 'Sean', email: 'sean@lumiden.com', role: 'admin' },
      { user_id: '@alice:lumiden.kaiandco.ai', display_name: 'Alice', email: 'alice@lumiden.com', role: 'member' },
      { user_id: '@bob:lumiden.kaiandco.ai', display_name: 'Bob', email: 'bob@lumiden.com', role: 'member' },
    ],
    services: [
      {
        name: 'synapse', full_name: 'lumiden-synapse', status: 'ACTIVE', running: 0, desired: 1, pending: 1, healthy: false,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-synapse',
        launch_type: 'FARGATE',
        created_at: '2025-01-15T10:02:00Z',
        deployments: [
          { status: 'PRIMARY', running: 0, desired: 1, pending: 1, created_at: '2025-03-12T08:00:00Z', updated_at: '2025-03-12T08:15:00Z' },
        ],
        events: [
          { message: '(service lumiden-synapse) has started 1 tasks: (task abc123).', created_at: new Date(Date.now() - 900_000).toISOString() },
          { message: '(service lumiden-synapse) was unable to place a task because no container instance met all of its requirements.', created_at: new Date(Date.now() - 1_800_000).toISOString() },
          { message: '(service lumiden-synapse) has stopped 1 running tasks: (task def456). Reason: Essential container in task exited.', created_at: new Date(Date.now() - 3_600_000).toISOString() },
        ],
      },
      {
        name: 'kai', full_name: 'lumiden-kai', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-kai',
        launch_type: 'FARGATE',
        created_at: '2025-01-15T10:05:00Z',
        deployments: [
          { status: 'PRIMARY', running: 1, desired: 1, pending: 0, created_at: '2025-03-10T12:00:00Z', updated_at: '2025-03-10T12:05:00Z' },
        ],
        events: [
          { message: '(service lumiden-kai) has reached a steady state.', created_at: new Date(Date.now() - 86_400_000).toISOString() },
        ],
      },
      {
        name: 'mia', full_name: 'lumiden-mia', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-mia',
        launch_type: 'FARGATE',
        created_at: '2025-01-15T10:05:00Z',
        deployments: [
          { status: 'PRIMARY', running: 1, desired: 1, pending: 0, created_at: '2025-03-10T12:00:00Z', updated_at: '2025-03-10T12:05:00Z' },
        ],
        events: [],
      },
      {
        name: 'finn', full_name: 'lumiden-finn', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-finn',
        launch_type: 'FARGATE',
        created_at: '2025-01-20T14:00:00Z',
        deployments: [
          { status: 'PRIMARY', running: 1, desired: 1, pending: 0, created_at: '2025-03-10T12:00:00Z', updated_at: '2025-03-10T12:05:00Z' },
        ],
        events: [],
      },
      {
        name: 'sam', full_name: 'lumiden-sam', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-sam',
        launch_type: 'FARGATE',
        created_at: '2025-01-20T14:00:00Z',
        deployments: [
          { status: 'PRIMARY', running: 1, desired: 1, pending: 0, created_at: '2025-03-10T12:00:00Z', updated_at: '2025-03-10T12:05:00Z' },
        ],
        events: [],
      },
      {
        name: 'luna', full_name: 'lumiden-luna', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-luna',
        launch_type: 'FARGATE',
        created_at: '2025-02-01T09:00:00Z',
        deployments: [
          { status: 'PRIMARY', running: 1, desired: 1, pending: 0, created_at: '2025-03-10T12:00:00Z', updated_at: '2025-03-10T12:05:00Z' },
        ],
        events: [],
      },
      {
        name: 'webapp', full_name: 'lumiden-webapp', status: 'ACTIVE', running: 1, desired: 1, pending: 0, healthy: true,
        arn: 'arn:aws:ecs:us-east-1:123:service/kaiandco-teams/lumiden-webapp',
        launch_type: 'FARGATE',
        created_at: '2025-01-15T10:05:00Z',
        deployments: [
          { status: 'PRIMARY', running: 1, desired: 1, pending: 0, created_at: '2025-03-11T16:00:00Z', updated_at: '2025-03-11T16:03:00Z' },
        ],
        events: [],
      },
    ],
    tasks: [
      {
        task_id: 'abc12345678901234567890123456789',
        status: 'RUNNING',
        desired_status: 'RUNNING',
        health_status: 'HEALTHY',
        started_at: new Date(Date.now() - 86_400_000 * 2).toISOString(),
        group: 'service:lumiden-kai',
        containers: [
          { name: 'company-agent', status: 'RUNNING', exit_code: null, health_status: 'HEALTHY' },
          { name: 'opencode', status: 'RUNNING', exit_code: null, health_status: '' },
        ],
      },
      {
        task_id: 'def45678901234567890123456789012',
        status: 'PENDING',
        desired_status: 'RUNNING',
        health_status: '',
        started_at: new Date(Date.now() - 900_000).toISOString(),
        group: 'service:lumiden-synapse',
        containers: [
          { name: 'synapse', status: 'PENDING', exit_code: null, health_status: '' },
        ],
      },
    ],
    summary: {
      agent_count: 5,
      member_count: 3,
      service_count: 7,
      task_count: 2,
      healthy_services: 6,
      unhealthy_services: 1,
    },
  },
};

export const mockPlatformHealth: PlatformHealthResponse = {
  overall_status: 'degraded',
  ecs_cluster: {
    status: 'ACTIVE',
    active_services: 23,
    running_tasks: 22,
    pending_tasks: 1,
    total_services: 23,
    total_tasks: 23,
  },
  rds: {
    status: 'available',
    engine: 'postgres',
    engine_version: '15.4',
    instance_class: 'db.t4g.medium',
    storage_gb: 50,
    multi_az: false,
    endpoint: 'kaiandco-teams-synapse.abc123.us-east-1.rds.amazonaws.com',
  },
  alb: {
    status: 'active',
    dns_name: 'kaiandco-teams-alb-123456.us-east-1.elb.amazonaws.com',
    type: 'application',
    target_groups: [
      { name: 'lumiden-synapse-tg', healthy_targets: 0, unhealthy_targets: 1, total_targets: 1 },
      { name: 'lumiden-webapp-tg', healthy_targets: 1, unhealthy_targets: 0, total_targets: 1 },
      { name: 'acme-corp-synapse-tg', healthy_targets: 1, unhealthy_targets: 0, total_targets: 1 },
      { name: 'acme-corp-webapp-tg', healthy_targets: 1, unhealthy_targets: 0, total_targets: 1 },
      { name: 'beta-test-synapse-tg', healthy_targets: 1, unhealthy_targets: 0, total_targets: 1 },
    ],
  },
  lambda_errors_1h: {
    gateway: 0,
    auth: 2,
    teams: 0,
    ops: 0,
  },
  checked_at: new Date().toISOString(),
};
